import React from 'react';
import {
	connect
} from 'react-redux'
import PackingComponent from '../components/PackingComponent.jsx';
import {
	changePackingOrderId,
	findAllOrderIds,
	changePackingEventKey,
	findPackingItemList,
	findDistinctCategories,
	findPackingBoxNumbers,
	findUnPackingItemCount,
	clearPackingAlert
} from '../actions';

function generateUnPackingItemMessage(unPackingItemCount) {
	let unPackingItemMessage = [];
	for (let i = 0; i < unPackingItemCount.size; i++) {
		let gearName = unPackingItemCount.get(i).get('customer_gear_name');
		let orderDetailId = unPackingItemCount.get(i).get('order_detail_id');
		let cnt = unPackingItemCount.get(i).get('cnt');
		unPackingItemMessage.push((<h5 key={orderDetailId}>{cnt} 筆 {gearName} 未裝箱</h5>));
	}
	return unPackingItemMessage;
}

const mapStateToProps = (state) => ({
	orderId: state.getIn(['packingReducer', 'orderId']),
	allOrderIds: state.getIn(['packingReducer', 'allOrderIds']),
	eventKey: state.getIn(['packingReducer', 'eventKey']),
	activePage: state.getIn(['packingListReducer', 'activePage']),
	itemPerPage: state.getIn(['packingListReducer', 'itemPerPage']),
	unPackingItemMessage: generateUnPackingItemMessage(state.getIn(['packingReducer', 'unPackingItemCount'])),
})

const mapDispatchToProps = (dispatch) => ({
	changeOrderId: (payload) => {
		dispatch(changePackingOrderId(payload));
	},
	changeEventKey: (key) => {
		dispatch(changePackingEventKey(key));
	},
	findAllOrderIds: () => {
		dispatch(findAllOrderIds());
	},
	findPackingItemList: (payload) => {
		dispatch(findPackingItemList(payload, { activePage: 1, itemPerPage: 10 }));
	},
	findDistinctCategories: (payload) => {
		dispatch(findDistinctCategories(payload));
	},
	findPackingBoxNumbers: (payload) => {
		dispatch(findPackingBoxNumbers(payload));
	},
	findUnPackingItemCount: (payload) => {
		dispatch(findUnPackingItemCount(payload));
	},
	clearPackingAlert: () => {
		dispatch(clearPackingAlert());
	},
})

const PackingContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(PackingComponent)

export default PackingContainer;


// WEBPACK FOOTER //
// ./src/containers/PackingContainer.jsx